import {EnvironmentModel} from './environment.model';
import * as env from './environment.json';

/**
 * @constant
 * @description This constant is the environment model of our environment.json file.
 * @exports {EnvironmentModel}
 * @name environment
 * @type {EnvironmentModel}
 */
export const environment: EnvironmentModel = EnvironmentModel.fromObject(env);
